module.exports = __webpack_public_path__ + "static/img/BR.b04501a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/BR.png
// module id = btX6
// module chunks = 1